export default __webpack_public_path__ + "static/media/paytrie_walkthrough_0.bd99a981.bin";